function initialisiereMarketingKampagnenBoxen() {
    // alle Marketing-Kampagnen-Boxen holen
    let marketingKampagnenBoxen = document.getElementsByClassName('iww-box-marketing');
    for (const marketingKampagnenBox of marketingKampagnenBoxen) {
        let i = 0,
            marketingKampagnen = marketingKampagnenBox.getElementsByClassName('iww-box-marketing-content'),
            navButtons = marketingKampagnenBox.getElementsByClassName('iww-hoverbutton');

        if (marketingKampagnen.length !== 0) {
            // HTMLCollection zu einem Datenfeld (Array) konvertieren, um später dessen Funktionen nutzen zu können
            marketingKampagnen = [...marketingKampagnen];

            // 1. Marketing-Kampagne sichtbar + 1. Button aktivieren
            marketingKampagnen[0].style.display = 'flex';
            navButtons[0].ariaHidden = 'true';

            // andere Marketing-Kampagnen verstecken
            for (i = 1; i < marketingKampagnen.length; i++) {
                marketingKampagnen[i].style.display = 'none';
            }

            // Klick-Listener für den Button
            let navButtonClickListener = function () {
                let key = this.getAttribute('data-key');
                for (i = 0; i < navButtons.length; i++) {
                    marketingKampagnen[i].style.display = 'none';
                    navButtons[i].ariaHidden = 'false';
                }
                this.ariaHidden = 'true';
                marketingKampagnen
                    .filter((marketingKampagne) => marketingKampagne.getAttribute('data-slide') === key)
                    .shift().style.display = 'flex';
            };

            // Klick-Listener auf die Buttons setzen
            for (let i = 0; i < navButtons.length; i++) {
                navButtons[i].addEventListener('click', navButtonClickListener, false);
            }
        }
    }
}

document.addEventListener('DOMContentLoaded', function (event) {
    initialisiereMarketingKampagnenBoxen();
});
